var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./errorDisplay.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1ceacef6\"}!../../../vue-loader/lib/selector?type=template&index=0!./errorDisplay.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-formly-bootstrap/src/components/errorDisplay.vue
// module id = 1076
// module chunks = 0